import { EpisodeRibbonDataSource } from './EpisodeRibbonDataSource';
import { VodApi } from '../../api/VodApi';
import { DetailTranslationKeys, SettingsKeys } from '../../api/models/TranslationKeys';
import { CmsProperty } from '../../api/models/Shared.types';
import { Theme } from '../../config/theme';
import { CmsTabbedRibbon } from '../../components/cms/CmsTabbedRibbon';
import { Backend } from '../../api/Backend';
import { VodAsset } from '../detail/vod/VodAsset';
import { CardSizeInfo } from './CardSizeInfo';
import { TabbedDs } from './TabbedEpgEpisodesRibbonDataSource';
import { IAssetSummary } from '../../api/models/AndromeTV.types';
import { DataSource } from './DataSource';

/**
 * @property {Backend} backend
 * @property {DataSource[]} dataSources
 */
export class TabbedEpisodeRibbonDataSource extends DataSource {
  private vod: VodAsset;
  private title: string;
  private seasonRibbons: TabbedDs[] = [];
  private buttonHeight: number;
  private sizeInfo: CardSizeInfo | undefined;
  private seasons: IAssetSummary[] | undefined;
  /**
   * @param {Backend} backend
   * @param {VodAsset} vod
   * @param title
   * @param [buttonHeight]
   */
  constructor(backend: Backend, vod: VodAsset, title: string, buttonHeight = 58) {
    super(backend);
    this.backend = backend;
    this.vod = vod;
    this.title = title;
    this.buttonHeight = buttonHeight;

    this.sizeInfo = undefined;
  }

  /**
   * @returns {Promise<*>}
   */
  override load() {
    const seasons = this._getSeasonDataSources();

    return seasons.then(seasons => {
      seasons = seasons || [];
      this.seasonRibbons = [];
      if (seasons.length > 0) {
        let properties = this.backend.globalSettings.stringArray(SettingsKeys.propertiesVodDetailEpisodesRibbon);
        properties = properties
          ? properties
          : [CmsProperty.ShowProgress, CmsProperty.ShowEpisodeInfo, CmsProperty.HideInfo];
        this.seasonRibbons = seasons.map(season => {
          return {
            dataSource: new EpisodeRibbonDataSource(this.backend, season.id, properties!),
            title: season.season
              ? `${this.backend.translations.forKey(DetailTranslationKeys.detail_season)} ${season.season}`
              : season.title,
          };
        });
        this.sizeInfo = new CardSizeInfo();
        return this.seasonRibbons;
      }
    });
  }

  _getSeasonDataSources(): Promise<IAssetSummary[] | undefined> {
    if (this.seasons) {
      return Promise.resolve(this.seasons);
    }

    let seasonListProm;
    if (this.vod.seasons && this.vod.seasons.length > 0) {
      seasonListProm = Promise.resolve(this.vod.seasons);
    } else {
      if (this.vod.seriesId) {
        seasonListProm = VodApi.asset(this.backend, this.vod.seriesId).then(result => {
          return result.seasons;
        });
      } else {
        seasonListProm = Promise.resolve([]);
      }
    }

    return seasonListProm.then(seasons => {
      this.seasons = seasons?.sort((a: IAssetSummary, b: IAssetSummary) => (a.season || 0) - (b.season || 0));
      return this.seasons;
    });
  }

  override isEmpty(): boolean {
    return !this.seasonRibbons || this.seasonRibbons.length === 0;
  }

  totalHeight(): number {
    return Theme.Fonts.Ribbon.Title.lineHeight + this.buttonHeight + (this.sizeInfo ? this.sizeInfo.height : 0);
  }

  override componentDescription() {
    return {
      focusable: true,
      type: CmsTabbedRibbon,
      data: this,
      h: this.totalHeight(),
    };
  }
}
